/**
 * Moved to `shared/src/review/page-evidence.ts` so the review surface and the server-side
 * export read one copy of this logic. Edit it there.
 *
 * Named rather than `export *`: the Vite dev server's CommonJS interop runs a
 * star re-export before the module it re-exports has loaded.
 */
export {
  buildPageEvidencePanel,
  isPageEvidenceEmpty
} from '@taptimize/shared/dist/review/page-evidence';
export type {
  EvidenceTone,
  PageEvidence,
  PageEvidencePanel
} from '@taptimize/shared/dist/review/page-evidence';
